<template>
  <div>
    <BaseTable
      :items="list"
      :headers="tableHeaders"
      :loading="loading"
      :pagination="paginationConfig"
      :idPrefix="idPrefix"
      clickable
      @rowClicked="onClickingCategory"
    >
      <!-- Custom item slot -->
      <template #item="{ item }">
        <td class="p-4 text-sm text-gray-900">
          <div>
            {{ item?.id }}
          </div>
        </td>
        <td class="p-4 text-sm text-gray-900 flex items-center gap-3">
          <div class="w-10 h-10">
            <img class="w-full h-full" :class="{ 'gray-scale': !item?.enabled }" :src="item?.imageURI"/>
          </div>
          <div>
            {{ item?.name }}
          </div>
        </td>
        <td class="p-4 text-sm text-gray-500 relative overflow-hidden">
          <div class="flex gap-4">
          <button
            title="Edit"
            class="text-gray-600 hover:text-white bg-gray-50 hover:bg-gray-600 rounded-full transition-colors flex items-center justify-center w-9 h-9 shadow-md border-none cursor-pointer" @click.stop="onClickingEdit(item?.id)">
            <i class="far fa-edit"></i>
          </button>
          <button
            title="Delete"
            class="text-red-600 hover:text-white bg-red-50 hover:bg-red-600 rounded-full transition-colors flex items-center justify-center w-9 h-9 shadow-md border-none cursor-pointer"
            @click.stop="onDeleteClicked(item?.id)">
            <i aria-hidden="true" class="fa fa-trash"></i>
          </button>
          <button
            :title="item?.enabled ? 'Disable' : 'Enable'"
            class="text-blue-600 hover:text-white bg-blue-50 hover:bg-blue-600 rounded-full transition-colors flex items-center justify-center w-9 h-9 shadow-md border-none cursor-pointer"
            @click.stop="onToggleClicked(item)">
            <i :class="{'fa fa-low-vision': item?.enabled, 'fas fa-eye': !item?.enabled}"></i>
          </button>

          <div
            class="absolute text-xs bg-gray-600 text-white w-full text-center rotate-45"
            :class="{'none': item?.enabled}">Disabled</div>
        </div>
        </td>
      </template>

      <!-- Empty state slot -->
      <template #empty> No Categories found </template>
    </BaseTable>
  </div>
</template>

<script>
import { translations } from '@/mixins';
import BaseTable from '@/components/BaseTable.vue';

export default {
  name: 'CategoriesList',

  components: {
    BaseTable,
  },

  mixins: [translations],

  props: {
    list: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      idPrefix: 'categories.',
      tableHeaders: [],
    };
  },

  created () {
    this.tableHeaders = [
      {
        label: this.translate('ID'),
        id: 'headercategoryid',
        width: 'w-20',
      },
      {
        label: this.translate('Name'),
        id: 'headercategoryname',
      },
      {
        label: this.translate('Action'),
        id: 'headeraction',
      },
    ];
  },

  computed: {
    paginationConfig () {
      return {
        enabled: false,
      };
    },
  },

  methods: {
    onToggleClicked (category) {
      this.$emit('enableDisableCategory', category);
    },
    onDeleteClicked (categoryId) {
      this.$emit('onDeleteClicked', categoryId);
    },
    onClickingCategory (item) {
      this.$router.push({ name: 'category details', params: { categoryId: item?.id } });
    },
    onClickingEdit (categoryId) {
      this.$router.push({ name: 'category details', params: { categoryId: categoryId }, query: { tab: 'update_category' } });
    },
  },
};
</script>

<style scoped>
  .rotate-45 {
    transform: rotate(45deg);
    right: -45%;
  }
  .none {
    display: none;
  }
  .gray-scale {
    filter: grayscale(100%);
  }
</style>
